import { render, staticRenderFns } from "./ConfirmationStep.vue?vue&type=template&id=1d6b457b&scoped=true&"
import script from "./ConfirmationStep.vue?vue&type=script&lang=js&"
export * from "./ConfirmationStep.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationStep.vue?vue&type=style&index=0&id=1d6b457b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b457b",
  null
  
)

export default component.exports